module.exports = `${require.publicPath}southbay.9e0c719a.png`;